import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

const NotificationDrawer = ({ show, onClose }) => {
  const drawerRef = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (drawerRef.current && !drawerRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  const notifications = [
   
    ...Array.from({ length: 18 }, (_, i) => ({
      id: i + 1,
      name: 'User ' + (i + 1),
      amount: '780.1',
      time: '9:01am',
      benStatus: i % 3 === 0 ? 'pending' : 'success',
      status: i % 2 === 0 ? 'pending' : 'received',
      section: i < 6 ? 'Today' : i < 12 ? 'Yesterday' : 'This Week',
    })),
  ];

  const grouped = notifications.reduce((acc, item) => {
    acc[item.section] = acc[item.section] || [];
    acc[item.section].push(item);
    return acc;
  }, {});

  const [page, setPage] = useState({});

  const handlePageChange = (section, direction) => {
    setPage((prev) => ({
      ...prev,
      [section]: Math.max(
        0,
        Math.min(
          Math.ceil(grouped[section].length / 6) - 1,
          (prev[section] || 0) + direction
        )
      ),
    }));
  };

  return (
    <div
      className={`fixed inset-0 z-50 transition-transform duration-300 ${show ? "translate-x-0" : "translate-x-full"}`}
    >
      <div className="absolute inset-0 bg-black bg-opacity-30" />

      <div
        ref={drawerRef}
        className="absolute right-0 top-0 h-full w-full bg-[#fcfbf9] shadow-lg p-6 overflow-y-auto transition-transform duration-300"
      >
        <div className="flex items-center space-x-3 cursor-pointer border-b pb-4">
          <img onClick={onClose} src="./arrow-left.svg" alt="back" />
          <h2 className="text-lg font-bold w-full -ml-6">Notifications</h2>
        </div>

        <div className="space-y-6 mt-4">
          {Object.entries(grouped).map(([section, items]) => {
            const currentPage = page[section] || 0;
            const pagedItems = items.slice(currentPage * 6, currentPage * 6 + 6);
            const totalPages = Math.ceil(items.length / 6);

            return (
              <div key={section}>
                <h3 className="text-sm font-semibold mb-2">{section}</h3>

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                  {pagedItems.map((notif) => (
                    <div
  key={notif.id}
  className={`flex items-center justify-between p-3 bg-[#E6E6E6] ${notif.status === 'pending' ? 'rounded-lg' : ''}`}
>

                      <div className="flex items-center gap-3">
                        <img
                          src="https://avataaars.io/?avatarStyle=Circle"
                          alt="User"
                          className="w-10 h-10 rounded-full"
                        />
                        <div className="text-sm">
                          {notif.benStatus === 'pending' ? (
                            <p>Your payment of <strong>${notif.amount}</strong> is pending, please add beneficiary details</p>
                          ) : notif.status === 'pending' ? (
                            <p>Your payment of <strong>${notif.amount}</strong> is pending</p>
                          ) : (
                            <p>You received a payment of <strong>${notif.amount}</strong><br />from <strong>{notif.name}</strong></p>
                          )}
                          <p className="text-xs text-gray-500 mt-1">{notif.time}</p>
                        </div>
                      </div>
                      {notif.status === 'pending' && (
                        <button className="bg-[#0B214E] text-white px-3 py-1 rounded-md text-sm">
                          PAY
                        </button>
                      )}
                    </div>
                  ))}
                </div>

                {totalPages > 1 && (
                  <div className="flex justify-center items-center mt-2 space-x-4 text-sm">
                    <button
                      className="px-2 py-1 border rounded disabled:opacity-50"
                      disabled={currentPage === 0}
                      onClick={() => handlePageChange(section, -1)}
                    >
                      Prev
                    </button>
                    <span>Page {currentPage + 1} of {totalPages}</span>
                    <button
                      className="px-2 py-1 border rounded disabled:opacity-50"
                      disabled={currentPage + 1 >= totalPages}
                      onClick={() => handlePageChange(section, 1)}
                    >
                      Next
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

NotificationDrawer.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default NotificationDrawer;
